module.exports = __webpack_public_path__ + "static/media/IADL6e42ea89.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/IADL.svg
// module id = 1301
// module chunks = 0